import { Button, Form } from 'antd';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { FAIcon } from '../../../../components/adapters/fontAwesomeAdapters';
import { useFormContext } from '../../../../components/forms/forms';
import { toServerDateTimeOptional } from '../../../../common/utils/dateUtils';
import { useNewShipmentFlightInformationFormStyles } from '../../newShipment/NewShipmentFlightInformationForm.styles';

function AddFlightButton({ onChange, disabled }) {
  const { formInstance } = useFormContext();

  const onAddFlight = () => {
    const allFields = formInstance.getFieldsValue();
    const fieldNames = Object.keys(allFields);
    const fieldsToValidate = fieldNames.filter(name => name !== 'flight');
    formInstance
      .validateFields(fieldsToValidate)
      .then(
        ({
          manualDepartureAirport,
          manualArrivalAirport,
          manualAirline,
          manualFlightNumber,
          manualDeparture,
          manualArrival,
        }) => {
          onChange({
            airline: manualAirline?.code,
            flightNumber: manualFlightNumber,
            arrivalDatetime: toServerDateTimeOptional(manualArrival),
            arrivalCity: manualArrivalAirport?.city,
            arrivalAirport: manualArrivalAirport?.airport,
            arrivalCountry: manualArrivalAirport?.country,
            arrivalState: manualArrivalAirport?.state,
            departureDatetime: toServerDateTimeOptional(manualDeparture),
            departureState: manualDepartureAirport?.state,
            departureAirport: manualDepartureAirport?.airport,
            departureCountry: manualDepartureAirport?.country,
            departureCity: manualDepartureAirport?.city,
          });
        }
      );
  };

  return (
    <Button
      data-subject="manual-flight"
      data-action="add-manual-flight"
      id="add-manual-flight"
      disabled={disabled}
      onClick={onAddFlight}
    >
      <FAIcon icon="plus" />
      <span>
        <FormattedMessage id="book.newAirRetrieval.manual.addButton" />
      </span>
    </Button>
  );
}

export default function FormItemAddFlight({ disabled }) {
  const { formatMessage: f } = useIntl();
  const { styles } = useNewShipmentFlightInformationFormStyles();

  return (
    <Form.Item
      name="flight"
      className={styles.addFlightButton}
      rules={[
        {
          required: true,
          message: f({ id: 'book.newAirRetrieval.error.addFlight' }),
        },
      ]}
    >
      <AddFlightButton disabled={disabled} />
    </Form.Item>
  );
}
